import React from "react";
// import NavbarAlert from "../../components/navbar-alert";
import NavbarButtonBar from "../../components/navbar-button-bar";
// import NavbarFormSearch from "../../components/navbar-form-search";
import NavbarLogout from "../../components/navbar-logout";
// import NavbarMessage from "../../components/navbar-message";
import NavbarWelcomeMessage from "../../components/navbar-welcome-message";

const Header = () => {
  return (
    <>
      <div className="row border-bottom">
        <nav
          className="navbar navbar-static-top"
          role="navigation"
          style={{ marginBottom: 0 }}
        >
          <div className="navbar-header">
            <NavbarButtonBar />
            {/* <NavbarFormSearch /> */}
          </div>
          <ul className="nav navbar-top-links navbar-right">
            <NavbarWelcomeMessage />
            {/* <NavbarMessage /> */}
            {/* <NavbarAlert /> */}
            <NavbarLogout />
          </ul>
        </nav>
      </div>
    </>
  );
};

export default Header;
